// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"2611fc42","147":"016c9565","171":"4ffd3429","374":"efd6ef66","429":"f469e127","466":"2cdce70e","507":"4cd69178","546":"960561a1","780":"31bc4a75"}[chunkId] + ".chunk.js";
};